import { InstructionEmailForm } from '@/features/ap_payees/components/DocInstructionMenu/types';
import { useTranslation } from '@/i18n';
import { ButtonGroup, ButtonV2 } from '@moneyforward/ap-frontend-components';
import cx from 'classnames';
import React, { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import styles from '../index.module.scss';

interface InstructionFooterProps {
  onCancel: () => void;
  onSendEmails: (onSuccess?: () => void) => void;
  isSendingEmail?: boolean;
}

export const InstructionFooter: React.FC<InstructionFooterProps> = ({
  onCancel,
  onSendEmails,
  isSendingEmail = false,
}) => {
  const { t } = useTranslation();

  const successSendEmailCallback = useCallback(() => {
    onCancel();
    location?.reload();
  }, [onCancel]);

  const onClickSendMail = useCallback(async () => {
    const result = confirm(t('send_instruction_email_dialog_confirm'));
    if (result) {
      onSendEmails(successSendEmailCallback);
    }
  }, [onSendEmails, successSendEmailCallback, t]);

  const {
    formState: { isValid },
  } = useFormContext<InstructionEmailForm>();
  return (
    <div className={cx(styles.footer_container)}>
      <ButtonGroup direction='horizontal'>
        <ButtonV2 color='primary' isSecondary onClick={onCancel} size='sm'>
          {t('send_instruction_email_dialog_cancel')}
        </ButtonV2>
        <ButtonV2
          color='primary'
          onClick={onClickSendMail}
          size='sm'
          isLoading={isSendingEmail}
          isDisabled={isSendingEmail || !isValid}
        >
          {t('send_instruction_email_dialog')}
        </ButtonV2>
      </ButtonGroup>
    </div>
  );
};
